(ns iris.websocket.heartbeat
  (:require [re-frame.core :as rf]
            [iris.websocket.client :as ws-client]))

(defonce heartbeat-timer (atom nil))
(defonce refresh-interval (atom nil))

;; Keep your EXISTING heartbeat/send event unchanged!
;; Just look for the existing one - probably looks like this:
(rf/reg-event-fx
 :iris.websocket.heartbeat/send
 (fn [{:keys [db]} _]
   (let [fp (:fp db)
         dfp (:dfp db)
         authenticated? (get-in db [:websocket :authenticated])
         uid (get-in db [:jwt-payload :uid])
         identity (if (and authenticated? uid)
                    uid
                    fp)]
     (js/console.log "Heartbeat: identity=" identity "authenticated=" authenticated? "uid=" uid "fp=" fp)
     (when (and identity (ws-client/connected?))
       {:ws/send {:type "heartbeat"
                  :identity identity
                  :fp fp
                  :fpdevice (or dfp "")}}))))

;; MODIFY the start event to add refresh timer
(rf/reg-event-fx
 :iris.websocket.heartbeat/start
 (fn [{:keys [db]} _]
   ;; Start heartbeat timer
   (when @heartbeat-timer
     (js/clearInterval @heartbeat-timer))
   (reset! heartbeat-timer
           (js/setInterval #(rf/dispatch [:iris.websocket.heartbeat/send]) 30000))
   
   ;; NEW: Start online users refresh (every 2 minutes)
   (when @refresh-interval
     (js/clearInterval @refresh-interval))
   (reset! refresh-interval
           (js/setInterval #(rf/dispatch [:iris.websocket/get-online-users])
                          (* 2 60 1000)))
   
   ;; Send initial heartbeat and get initial online users
   {:dispatch [:iris.websocket.heartbeat/send]
    :dispatch-later [{:ms 500 :dispatch [:iris.websocket/get-online-users]}]}))

;; MODIFY the stop event to clear refresh timer
(rf/reg-event-fx
 :iris.websocket.heartbeat/stop
 (fn [_ _]
   (when @heartbeat-timer
     (js/clearInterval @heartbeat-timer)
     (reset! heartbeat-timer nil))
   
   ;; NEW: Stop refresh
   (when @refresh-interval
     (js/clearInterval @refresh-interval)
     (reset! refresh-interval nil))
   {}))

;; NEW: Event to manually request online users
(rf/reg-event-fx
 :iris.websocket/get-online-users
 (fn [_ _]
   (if (ws-client/connected?)
     {:ws/send {:type "get_online_users"}}
     {})))

